var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.08 49.0909C94.08 45.6873 93.7745 42.4145 93.2072 39.2727H48V57.84H73.8327C72.72 63.84 69.3382 68.9237 64.2545 72.3273V84.371H79.7672C88.8436 76.0146 94.08 63.7091 94.08 49.0909Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 96C60.96 96 71.8255 91.7018 79.7673 84.3709L64.2545 72.3273C59.9564 75.2073 54.4582 76.9091 48 76.9091C35.4982 76.9091 24.9164 68.4655 21.1418 57.12H5.10545V69.5564C13.0036 85.2436 29.2364 96 48 96Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1418 57.12C20.1818 54.24 19.6364 51.1637 19.6364 48C19.6364 44.8364 20.1818 41.76 21.1418 38.88V26.4437H5.10545C1.85455 32.9237 0 40.2546 0 48C0 55.7455 1.85455 63.0764 5.10545 69.5564L21.1418 57.12Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 19.0909C55.0473 19.0909 61.3745 21.5127 66.3491 26.2691L80.1163 12.5018C71.8036 4.75636 60.9382 0 48 0C29.2364 0 13.0036 10.7564 5.10545 26.4436L21.1418 38.88C24.9164 27.5345 35.4982 19.0909 48 19.0909Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.56d213d9eab009a81b9c7242f031201e.svg";
export { ForwardRef as ReactComponent };